module.exports = __webpack_public_path__ + "img/productivity.cec49ce.png";